// Rootserver product data – spec values stay as product content.
// All translatable UI text uses tPrefix to look up i18n keys.

export const ROOTSERVER_TYPES = [
  {
    slug: 'linux',
    tPrefix: 'linux',
    badgeKey: 'badge_epyc',
    fromPrice: '4.95',
    penguinImage: '/images/penguin/penguin_hug_server.svg',
    penguinAlt: 'Linux Rootserver Mascot',
    numFeatures: 6,
    plans: [
      {
        name: 'Small Gen8',
        subtitleKey: 'linux_plan1_sub',
        price: '4.95',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=622',
        specs: [
          { labelKey: 'cpu',     value: '2 AMD Epyc vCores' },
          { labelKey: 'ram',     value: '4 GB ECC RAM' },
          { labelKey: 'storage', value: '50 GB NVMe' },
          { labelKey: 'traffic', value: '10 TB FairUse' },
          { labelKey: 'os',      value: 'Debian / Ubuntu / CentOS' },
        ],
      },
      {
        name: 'Medium Gen8',
        subtitleKey: 'linux_plan2_sub',
        price: '10.00',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=625',
        specs: [
          { labelKey: 'cpu',     value: 'up to 4 AMD Epyc vCores' },
          { labelKey: 'ram',     value: '8 GB ECC RAM' },
          { labelKey: 'storage', value: 'up to 200 GB NVMe' },
          { labelKey: 'traffic', value: '15 TB FairUse' },
          { labelKey: 'os',      value: 'Debian / Ubuntu / CentOS' },
        ],
      },
      {
        name: 'Big Gen8',
        subtitleKey: 'linux_plan3_sub',
        price: '12.00',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=626',
        specs: [
          { labelKey: 'cpu',     value: 'up to 6 AMD Epyc vCores' },
          { labelKey: 'ram',     value: '12 GB ECC RAM' },
          { labelKey: 'storage', value: 'up to 400 GB NVMe' },
          { labelKey: 'traffic', value: '15 TB FairUse' },
          { labelKey: 'os',      value: 'Debian / Ubuntu / CentOS' },
        ],
      },
      {
        name: 'Expert Gen8',
        subtitleKey: 'linux_plan4_sub',
        price: '15.00',
        originalPrice: '20.00',
        popular: true,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=628',
        specs: [
          { labelKey: 'cpu',     value: 'up to 8 AMD Epyc vCores' },
          { labelKey: 'ram',     value: '16 GB ECC RAM' },
          { labelKey: 'storage', value: 'up to 400 GB NVMe' },
          { labelKey: 'traffic', value: '15 TB FairUse' },
          { labelKey: 'os',      value: 'Debian / Ubuntu / CentOS' },
        ],
      },
      {
        name: 'Large Gen8',
        subtitleKey: 'linux_plan5_sub',
        price: '20.00',
        originalPrice: '30.00',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=624',
        specs: [
          { labelKey: 'cpu',     value: 'up to 8 AMD Epyc vCores' },
          { labelKey: 'ram',     value: '24 GB ECC RAM' },
          { labelKey: 'storage', value: 'up to 600 GB NVMe' },
          { labelKey: 'traffic', value: '15 TB FairUse' },
          { labelKey: 'os',      value: 'Debian / Ubuntu / CentOS' },
        ],
      },
      {
        name: 'Mega Gen8',
        subtitleKey: 'linux_plan6_sub',
        price: '25.00',
        originalPrice: '38.00',
        popular: false,
        soldOut: true, // no order link while sold out
        specs: [
          { labelKey: 'cpu',     value: 'up to 12 AMD Epyc vCores' },
          { labelKey: 'ram',     value: 'from 32 GB ECC RAM' },
          { labelKey: 'storage', value: 'up to 1,000 GB NVMe' },
          { labelKey: 'traffic', value: '15 TB FairUse' },
          { labelKey: 'os',      value: 'Debian / Ubuntu / CentOS' },
        ],
      },
    ],
  },
  {
    slug: 'windows',
    tPrefix: 'windows',
    badgeKey: 'badge_windows',
    fromPrice: '16.95',
    penguinImage: '/images/penguin/penguin_eat_windows.svg',
    penguinAlt: 'Windows Rootserver Mascot',
    numFeatures: 6,
    plans: [
      {
        name: 'Windows Small',
        subtitleKey: 'windows_plan1_sub',
        price: '16.95',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=307',
        specs: [
          { labelKey: 'cpu',     value: 'up to 4 vCores' },
          { labelKey: 'ram',     value: '8 GB RAM' },
          { labelKey: 'storage', value: 'up to 250 GB SSD / 500 GB HDD' },
          { labelKey: 'traffic', value: 'Unlimited FairUse' },
          { labelKey: 'os',      value: 'Server 2012 / 2016 / 2019' },
        ],
      },
      {
        name: 'Windows Medium',
        subtitleKey: 'windows_plan2_sub',
        price: '26.95',
        popular: true,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=308',
        specs: [
          { labelKey: 'cpu',     value: 'up to 6 vCores' },
          { labelKey: 'ram',     value: 'up to 16 GB RAM' },
          { labelKey: 'storage', value: 'up to 250 GB SSD / 500 GB HDD' },
          { labelKey: 'traffic', value: 'Unlimited FairUse' },
          { labelKey: 'os',      value: 'Server 2012 / 2016 / 2019' },
        ],
      },
      {
        name: 'Windows Large',
        subtitleKey: 'windows_plan3_sub',
        price: '29.95',
        popular: false,
        orderUrl: 'https://deinserverhost.de/store/cart.php?a=add&pid=309',
        specs: [
          { labelKey: 'cpu',     value: 'up to 6 vCores' },
          { labelKey: 'ram',     value: 'up to 32 GB RAM' },
          { labelKey: 'storage', value: 'up to 250 GB SSD / 500 GB HDD' },
          { labelKey: 'traffic', value: 'Unlimited FairUse' },
          { labelKey: 'os',      value: 'Server 2012 / 2016 / 2019' },
        ],
      },
    ],
  },
];

export function getRootserverBySlug(slug) {
  return ROOTSERVER_TYPES.find((r) => r.slug === slug) || null;
}
